import CustomBreadCrumb from '../../../components/Common/CustomBreadCrumb'
import React, { Component } from 'react'
import { Card, Layout, Row } from 'antd'
import List from '../../../components/Sales/ClientRegistration/List'

const { Content } = Layout

class ClientRegistration extends Component {
  render () {
    return (
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <CustomBreadCrumb items={[{ text: 'Client' }, { text: 'Registration' }]}/>
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card title={<h1>Client Registration</h1>}>
            <List {...this.props} />
          </Card>
        </Row>
      </Content>
    )
  }
}

export default ClientRegistration
